import { render, staticRenderFns } from "./projectsFindings.vue?vue&type=template&id=3c495270&scoped=true&"
import script from "./projectsFindings.vue?vue&type=script&lang=js&"
export * from "./projectsFindings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c495270",
  null
  
)

export default component.exports